import { render, staticRenderFns } from "./CheckmarkIcon.vue?vue&type=template&id=2dbb39d4"
import script from "./CheckmarkIcon.vue?vue&type=script&lang=ts"
export * from "./CheckmarkIcon.vue?vue&type=script&lang=ts"
import style0 from "./CheckmarkIcon.vue?vue&type=style&index=0&id=2dbb39d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports